import React, { Component } from 'react';

const Player = class extends Component {
  componentDidMount() {
    const { videoUrl } = this.props;

    /* eslint-disable no-undef */
    this.player = window.flowplayer(this.playerElement, {
      fullscreen: true,
      share: false,
      splash: true,
      clip: {
        sources: [{ type: 'video/mp4', src: videoUrl }]
      }
    });
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.shutdown();
    }
  }

  render = () => {
    const { thumb } = this.props;

    return (
      <div
        className="flowplayer is-splash"
        ref={elem => {
          this.playerElement = elem;
        }}
        style={{ backgroundImage: `url(${thumb})` }}
      />
    );
  };
};
export default Player;



// WEBPACK FOOTER //
// ./src/components/layout/Player.js